import './ConversationChatbox.css';
function ConversationChatbox({ messages }) {
    return (
        <div className='conversation_chatbox_main_container'>
            <div className='conversation_content'>
                {messages && messages.map(({ human, content, is_hidden }, index) => {
                    return (
                        is_hidden == 0 && (index == messages.length - 1 || messages[index + 1].is_hidden != 1) &&
                        <div key={index} className={"conversation_bubble_conv " + (human == 0 ? 'conversation_bubble_bot_conv' : 'conversation_bubble_human_conv')}>
                            {content}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ConversationChatbox;